/* eslint-disable react/prop-types */
import React from 'react';
import numeral from 'numeral';
import { Link } from 'react-router-dom';
import DefaultImage from '../../assets/images/Default-Actor-Image.png';

export const defaultSorts = ['shareOfVotes'];

export const columns = [
  {
    Header: '',
    accessor: (row, i) => i + 1,
    id: 'index',
    className: 'tvt-tabular-data-table__rank'
  },
  {
    Header: '',
    accessor: 'actorImageUrl',
    // )
    className: 'tvt-tabular-data-table__actor-image',
    Cell: ({ row: { original }, cell: { value } }) => (
      <img src={value || DefaultImage} alt={original.actor} />
    )
  },
  {
    Header: 'Actor',
    accessor: 'actor',
    className: 'tvt-tabular-data-table__actor-ranker-actor',
    Cell: ({ row: { original }, cell: { value } }) => (
      <Link to={`/actor/${original.actorId}`}>{value}</Link>
    )
  },
  {
    Header: 'Share of Votes',
    accessor: 'shareOfVotes',
    sortType: 'basic',
    sortDescFirst: true,
    className:
      'tvt-tabular-data-table__td-kpi tvt-tabular-data-table__actor-ranker-shareVotes caret-center',
    Cell: ({ cell: { value } }) => `${numeral(value).format('0.00')}%`
  },
  {
    Header: 'Fan Votes',
    accessor: 'votes',
    className:
      'tvt-tabular-data-table__td-kpi tvt-tabular-data-table__actor-ranker-votes',
    Cell: ({ cell: { value } }) => numeral(value).format('0,0')
  }
];

export default { columns, defaultSorts };
